import { render, staticRenderFns } from "./custom-native-smart-banner.vue?vue&type=template&id=40acb257&scoped=true"
import script from "./custom-native-smart-banner.vue?vue&type=script&setup=true&lang=js"
export * from "./custom-native-smart-banner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./custom-native-smart-banner.vue?vue&type=style&index=0&id=40acb257&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40acb257",
  null
  
)

export default component.exports